/** Canonical site origin for SEO, JSON-LD, and Open Graph (must match SeoHead). */
export const SITE_URL = 'https://proppins.com';
